import 'tslib';
import { useEffect } from 'react';
import '../../../services/base/baseDiscoverService.js';
import '../../../services/base/baseV3Service.js';
import '../../../services/base/baseInsightsService.js';
import '../../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../utils/ErrorProvider.js';
import { useLoader } from '../../../utils/LoaderProvider.js';
import { useRefetch } from '../../../utils/RefetchProvider.js';
import '../../../utils/NotificationProvider.js';
import '../../../utils/ContactProvider.js';
import '../../../utils/PolicyProvider.js';
import '../../../utils/AnalyticsProvider.js';
import '../../../types/AccessDevice.js';
import '../../../types/Analytics.js';
import '../../../types/CASACommunity.js';
import '../../../types/Community.js';
import '../../../types/DxSettings.js';
import '../../../types/MagicButton.js';
import '../../../types/Pannellum.js';
import '../../../types/Prospect.js';
import '../../../types/ProspectIntelligence.js';
import '../../../types/Space.js';
import '../../../types/Tour.js';
import '../../../utils/analyticsPlugin.js';
import '../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../utils/cookieUtils.js';
import '../../../utils/termsConditionsAgreementsUtils.js';
import '../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../services/base/internalApiBaseService.js';
import '../../../services/base/casaBaseService.js';
import '../../../services/scanRequestsService.js';
import '../../../services/db/insightsReportsDB.js';
import 'dot-object';
import '../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useSpaceByToken } from '../../../apis/space/useSpaceByToken.js';
import '../../../apis/upload/useSignedURL.js';
import { usePannellumViewer } from './PannellumProvider.js';
import { getStartNodeId, getNodeById } from './pannellumUtils.js';
import { useLoadScene } from './useNavigateScene.js';
import { useMultiResConfig } from './multiresStore.js';

const NavigateScene = ({ spaceToken }) => {
    const { details, sceneId, removeScene, isEditing, linkedSpaceDetails, setViewerContext, token } = usePannellumViewer();
    const { loadSceneWithStageCheck } = useLoadScene();
    const { context, refetch } = useRefetch();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [getSpaceByToken, spaceDetails, spaceByTokenInProgress, spaceByTokenError] = useSpaceByToken();
    const loadMultiRes = useMultiResConfig((s) => s.loadConfig);
    useEffect(() => {
        setLoader(spaceByTokenInProgress, "spaceByToken");
        return () => setLoader(false, "spaceByToken");
    }, [spaceByTokenInProgress]);
    useEffect(() => {
        if (spaceByTokenError) {
            setError && setError(spaceByTokenError === null || spaceByTokenError === void 0 ? void 0 : spaceByTokenError.message);
        }
    }, [spaceByTokenError]);
    useEffect(() => {
        if (spaceToken && linkedSpaceDetails) {
            if (!(linkedSpaceDetails === null || linkedSpaceDetails === void 0 ? void 0 : linkedSpaceDetails.nodes)) {
                getSpaceByToken({ token: spaceToken });
                return;
            }
            if (linkedSpaceDetails.isMultiRes) {
                const startNodeId = getStartNodeId(linkedSpaceDetails.nodes, linkedSpaceDetails.startNode);
                const startNode = getNodeById(linkedSpaceDetails.nodes, startNodeId);
                // Load initial node first
                loadMultiRes([startNode]).then(() => {
                    // Load rest of the nodes
                    loadMultiRes(linkedSpaceDetails.nodes.filter((node) => node._id !== startNodeId));
                    loadNewSceneContext(linkedSpaceDetails);
                });
            }
        }
    }, [spaceToken]);
    useEffect(() => {
        if (spaceDetails) {
            setViewerContext({
                linkedSpaceDetails: spaceDetails,
            });
            if (spaceDetails.isMultiRes) {
                const startNodeId = getStartNodeId(spaceDetails.nodes, spaceDetails.startNode);
                const startNode = getNodeById(spaceDetails.nodes, startNodeId);
                // Load initial node first
                loadMultiRes([startNode]).then(() => {
                    // Load rest of the nodes
                    loadMultiRes(spaceDetails.nodes.filter((node) => node._id !== startNodeId));
                    loadNewSceneContext(spaceDetails);
                });
            }
        }
    }, [spaceDetails]);
    const loadNewSceneContext = (_details) => {
        setViewerContext({
            details: _details,
            spaceToken: null,
            linkedSpaceDetails: null,
            token: spaceToken,
        });
        loadSceneWithStageCheck(getStartNodeId(_details.nodes, _details.startNode) || "", _details, spaceToken, true);
    };
    useEffect(() => {
        const nodeId = sceneId || (context === null || context === void 0 ? void 0 : context.sceneId) || getStartNodeId(details.nodes, details.startNode);
        removeScene(nodeId);
        loadSceneWithStageCheck(nodeId, details, token, true);
    }, [isEditing, context === null || context === void 0 ? void 0 : context.sceneId, refetch]);
    return null;
};

export { NavigateScene, NavigateScene as default };
